export default __webpack_public_path__ + "static/media/overviewBannerDesktop.faf1f085.png";